import React from "react";

import Design from "../../../../optics/components/drawers/templates/features/image-slider/designs/Design";
import { ImageSliderEditorContainer } from "./styles";
import { DesignContainer } from "../../../../optics/components/drawers/templates/features/image-slider/designs/styles";
import { useImageSliderStore } from "../../../../stores/use-image-slider-store";

const ImageSliderEditor = () => {
  const data = useImageSliderStore((state) => state.data);

  return (
    <ImageSliderEditorContainer>
      <DesignContainer>
        <Design data={data} canEdit />
      </DesignContainer>
    </ImageSliderEditorContainer>
  );
};

export default ImageSliderEditor;
